// @flow

import React from 'react';
import { Card, Button, Icon } from 'semantic-ui-react';
import ResourceImage from 'shared/components/ResourceImage';

type Props = {
  resource: BucketResource,
  isCreating: boolean,
  onSelect: (resource: BucketResource) => void,
};

const ResourceItem = ({ resource, isCreating, onSelect }: Props) => {
  const selectResource = () => onSelect(resource);

  return (
    <Card>
      <ResourceImage resource={resource} />
      <Card.Content>{resource.name}</Card.Content>
      <Button
        type="button"
        icon
        attached="bottom"
        disabled={isCreating}
        onClick={selectResource}
      >
        <Icon name="mouse pointer" />
        Sélectionner
      </Button>
    </Card>
  );
};

export default ResourceItem;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/components/ResourceItem.js